import { NgClass } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    Input,
    OnInit
} from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import { RequiredDirective } from "../../directives/required/required.directive";
import { ValidationMessageComponent } from "../../validation/validation-message/validation-message.component";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";
import { InfoComponent } from "../info/info.component";
import { InputProcessorType } from "../input/input-processor";
import { InputComponent } from "../input/input.component";
import { InputNumberValidator } from "./input-number.validator";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputNumberComponent)
        },
        {
            multi: false,
            provide: ControlValueAccessorBaseComponent,
            useExisting: forwardRef(() => InputNumberComponent)
        }
    ],
    selector: "rask-input-number",
    styleUrls: ["./input-number.component.scss"],
    templateUrl: "./input-number.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RequiredDirective,
        InfoComponent,
        NgClass,
        FormsModule,
        ValidationMessageComponent
    ]
})
export class InputNumberComponent extends InputComponent implements OnInit {

    @Input() min: number;
    @Input() max: number;
    @Input() step: number;
    @Input() unit: string;
    @Input() inputGroup: string;
    @Input() inputGroupRight: string;
    @Input() isDecimal = true;
    @Input() isNegative = true;
    @Input() useDecimalProcessor = false;

    ngOnInit() {
        super.ngOnInit();
        if (this.useDecimalProcessor && !this.inputProcessor) {
            this.inputProcessor = InputProcessorType.numberDecimalProcessor();
        }
    }

    protected onPaste(event: ClipboardEvent): void {
        const text = InputNumberValidator.scrubDirtyDataTransferText(event?.clipboardData.getData("text"));
        this.validateInput(text,event);
    }

    protected onDrop(event: DragEvent): void {
        const text = InputNumberValidator.scrubDirtyDataTransferText(event?.dataTransfer.getData("text"));
        this.validateInput(text,event);
    }

    protected onKeypress(event: KeyboardEvent): void {
        const text = event?.key;
        this.validateInput(text,event);
    }

    private validateInput(input: string, event: Event) {
        InputNumberValidator.validateEventInput(this.isDecimal, this.isNegative, this.min, this.max, input, this.customValue, event);
    }

}
